/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { Drawer, DrawerProps } from 'antd'
import styles from './styles.module.scss'

interface PropTypes extends DrawerProps {
	title: React.ReactNode
	icon: React.ReactNode
	show: boolean
	destroyOnClose?: boolean
	setShow: Function
	width?: string
}

export interface PanelProps extends PropTypes {}

const Panel: React.FC<PropTypes> = ({
	children,
	title,
	icon,
	show,
	setShow,
	width,

	...props
}) => {
	const closePanel = () => {
		setShow(false)
	}

	return (
		<Drawer
			className={styles.panel_drawer}
			title={
				<h3>
					{icon} {title}
				</h3>
			}
			placement='right'
			onClose={closePanel}
			visible={show}
			closable
			width={width || '55rem'}
			destroyOnClose
			{...props}
		>
			{children}
		</Drawer>
	)
}

Panel.defaultProps = {
	destroyOnClose: true,
	width: '55rem',
}

export default Panel
